const regionInput = document.querySelector('#consultant-inquiry-region');
if (regionInput) {
    const urlParams = new URLSearchParams(window.location.search);
    const region = urlParams.get('region');
    regionInput.value = region;
}
